import { popKeyword } from "../constants";

const initialState = {
    eDate:'',
    sDate:'',
    amount:'',
    timeStatus:'',
};

export function popKeywords(state = initialState, action) {
  switch (action.type) {
    case popKeyword.GET_DAY:
      return{
        ...state,
        sDate:action.sDate,
        eDate:action.eDate,
      }
    case popKeyword.SET_TIME_STATUS:
      return{
        ...state,
        timeStatus:action.timeStatus ? action.timeStatus : state.timeStatus,
      }
    case popKeyword.GET_AMOUNT:
      return{
        ...state,
        amount:action.amount ? action.amount : state.amount
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/popKeyword.reducer.js